import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { useUniboxColors } from "../../useUniboxColors";

/**
 * Botón de icono unificado (barra global de selección + visor de mensaje).
 * Siempre cuadrado con esquinas redondeadas (c.radius).
 */
export default function ToolbarIconButton({
  title,
  onClick,
  icon,
  variant = "default",
  active = false,
  disabled = false,
  size = 34,
}) {
  const c = useUniboxColors();

  const resolvedVariant = active ? "primary" : variant;

  const styles = {
    default: {
      bgcolor: c.toolbarBtn,
      color: c.textMuted,
      border: `1px solid ${c.border}`,
      hoverBg: c.toolbarBtnHover,
      hoverColor: c.accent,
      hoverBorder: c.accentBorder,
    },
    primary: {
      bgcolor: c.toolbarBtnActive,
      color: c.accent,
      border: `1px solid ${c.accentBorder}`,
      hoverBg: c.accentSoft,
      hoverColor: c.accent,
      hoverBorder: c.selectedBorder,
    },
    danger: {
      bgcolor: c.isDark ? "rgba(248, 113, 113, 0.14)" : "#fef2f2",
      color: c.isDark ? "#fca5a5" : "#dc2626",
      border: `1px solid ${c.isDark ? "rgba(248, 113, 113, 0.4)" : "#fecaca"}`,
      hoverBg: c.isDark ? "rgba(248, 113, 113, 0.24)" : "#fee2e2",
      hoverColor: c.isDark ? "#fecaca" : "#b91c1c",
      hoverBorder: c.isDark ? "#f87171" : "#fca5a5",
    },
  };

  const v = styles[resolvedVariant] || styles.default;

  return (
    <Tooltip title={title}>
      <span>
        <IconButton
          size="small"
          onClick={onClick}
          disabled={disabled}
          sx={{
            width: size,
            height: size,
            borderRadius: c.radius,
            bgcolor: v.bgcolor,
            color: v.color,
            border: v.border,
            transition: "all 0.15s ease",
            "&:hover": {
              bgcolor: v.hoverBg,
              color: v.hoverColor,
              borderColor: v.hoverBorder,
            },
            "&.Mui-disabled": {
              opacity: 0.45,
            },
          }}
        >
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  );
}
